import api from "../client";
import {
  malnutritionUseMocks,
  mockGetMalnutritionRiskAssessment,
  mockGetPatientWeights,
  mockSetMalnutritionFeedback,
} from "./mocks";

import type {
  MalnutritionFeedbackPayload,
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../../types/Malnutrition";

export const getMalnutritionRiskAssessment = async (
  emrPatientID: string,
  emrHospitalID: string
): Promise<MalnutritionRiskAssessment> => {
  if (malnutritionUseMocks())
    return mockGetMalnutritionRiskAssessment(emrPatientID);
  const response = await api.get("/patient-malnutrition/", {
    params: { emr_patient_id: emrPatientID, emr_hospital_id: emrHospitalID },
  });
  return response?.data;
};

export const getPatientWeights = async (
  emrPatientID: string,
  emrHospitalID: string
): Promise<PatientWeightHistory> => {
  if (malnutritionUseMocks()) return mockGetPatientWeights(emrPatientID);
  const response = await api.get("/patient-recent-weights/", {
    params: { emr_patient_id: emrPatientID, emr_hospital_id: emrHospitalID },
  });
  return response?.data;
};

// Records one step of the answer: the Yes/No choice, or the "which criteria
// didn't apply?" follow-up, which resends the No it follows. The click omits
// the follow-up's fields, which the server leaves untouched.
export const postMalnutritionFeedback = async (
  emrPatientID: string,
  emrHospitalID: string,
  payload: MalnutritionFeedbackPayload
): Promise<void> => {
  // In mock mode there's no backend to persist to; record it locally so the
  // read-back reflects it, then acknowledge without a network call.
  if (malnutritionUseMocks()) {
    mockSetMalnutritionFeedback(payload);
    return;
  }
  await api.post("/patient-malnutrition-feedback/", {
    emr_patient_id: emrPatientID,
    emr_hospital_id: emrHospitalID,
    ...payload,
  });
};
